import { SubAPI } from "./SubAPI";
export class EmailQueue extends SubAPI {
    get(props) { return this.fetcher.get("/api/email-queue/item", props); }
}
